import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LoadingBar } from '../../components/util/LoadingBar';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, LabelList, Legend } from 'recharts';
import { currencyFormatter } from '../../components/Money';

const CustomizedLabel = ({ value, ...props }) => {
  return (
    <text {...props} fontSize="16" dy={-4} dx={55} fill="black" textAnchor="middle">
      {currencyFormatter(value)}
    </text>
  );
};

class MaxTaxAdvantagedSavingsChart extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // we don't want to rerender if this data is unchanged. For some reason
    // recharts tried to rerender twice when changing the savings contribution
    // slider which caused labels on the bar graph to disappear.
    if (
      this.props.data[0].amount === nextProps.data[0].amount &&
      this.props.data[1].amount === nextProps.data[1].amount
    ) {
      return false;
    }
    return true;
  }

  render() {
    const { data } = this.props;
    if (!data) {
      return <LoadingBar />;
    }

    return (
      <BarChart width={400} height={300} data={data} margin={{ top: 50, right: 30, left: 20, bottom: 5 }} barGap={200}>
        <XAxis dataKey="name" dy="25" interval={0} tickSize tick={{ maxWidth: '100px' }} />
        <YAxis hide />
        <Bar dataKey="amount" barSize={110} label={<CustomizedLabel />}>
          {data.map(entry => <Cell fill={entry.withPlan ? '#66e2c5' : '#c4c4c4'} />)}
        </Bar>
      </BarChart>
    );
  }
}

export default connect()(MaxTaxAdvantagedSavingsChart);
